import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { parse } from 'url';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { switchMap } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { PortalInitializationService } from '../config/portal-initialization.service';

@Injectable()
export class PortalTokenInterceptor implements HttpInterceptor {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private appConfigService: AppConfigService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.appConfigService.tenant) {
      //until tenant is loaded it is not possible to get a security token
      return next.handle(request);
    }

    if (this.domainIsWhitelisted(request)) {
      return this.oidcSecurityService.getAccessToken().pipe(
        switchMap((token) => {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          return next.handle(request);
        })
      );
    } else {
      return next.handle(request);
    }
  }

  domainIsWhitelisted(request: HttpRequest<any>) {
    var requestUrl = parse(request.url, false, true);
    // We make an exception for the loading the environment settings.
    // We can't use the config service until then.
    return (
      requestUrl.pathname !== '/build-info.json' &&
      requestUrl.pathname !== PortalInitializationService.EnvironmentSettingsLocation &&
      requestUrl.hostname.includes(this.appConfigService.config.whitelistedPortalDomain)
    );
  }
}
